import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { loadProfile, saveProfile, type LocalProfile } from "./profile";

interface Ctx {
  profile: LocalProfile | null;
  setProfile: (p: LocalProfile | null) => void;
}

const LocalProfileContext = createContext<Ctx | null>(null);

export function LocalProfileProvider({ children }: { children: ReactNode }) {
  const [profile, setProfileState] = useState<LocalProfile | null>(() => loadProfile());

  // Persist whenever the profile changes (the helper functions in profile.ts
  // already save, but this catches any direct setProfile writes too).
  useEffect(() => {
    if (profile) saveProfile(profile);
  }, [profile]);

  return (
    <LocalProfileContext.Provider value={{ profile, setProfile: setProfileState }}>
      {children}
    </LocalProfileContext.Provider>
  );
}

export function useLocalProfile() {
  const ctx = useContext(LocalProfileContext);
  if (!ctx) throw new Error("useLocalProfile outside LocalProfileProvider");
  return ctx;
}
